import { SxProps, Theme } from '@mui/material';

export const panelSx: SxProps<Theme> = {
  p: 3,
  width: 'fit-content',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const linksPanelSx: SxProps<Theme> = {
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
};

export const linksSx: SxProps<Theme> = {
  fontWeight: 'bold',
  color: 'text.primary',
};
